import MainUIProviders from './MainUIProviders';

export default MainUIProviders;
